module.exports = __webpack_public_path__ + "img/account_expenditure.f3c9fbc4.svg";